<div class="card">
    <div class="company-name">{{ ctpVm.companyName }}</div>
    <div class="tax-branch">
        <span class="tax-id">{{ ctpVm.taxId }}</span
        >&nbsp;&nbsp;&nbsp;
        <span class="branch">{{ ctpVm.branch }}</span>
    </div>
    <div class="address">
        {{ ctpVm.address }}
    </div>

    <div class="foot-panel">
        <div>
            <dx-button
                text="เลือก"
                type="default"
                stylingMode="outlined"
                (onClick)="onSelectButtonClick()"
            ></dx-button>
        </div>
        <!-- Every result now comes from an external registry (dataforthai or
             the DBD API); the local counterparty store is gone. -->
        <div>
            <img width="55px" src="assets/dbd_logo.png" />
        </div>
    </div>
</div>
